<template>
    <tr v-bind="$attrs" :class="{ blue: active, 'darken-2': $vuetify.theme.dark, 'lighten-2': !$vuetify.theme.dark }">
        <td>
            <div class="d-flex">
                <div style="min-width: 3.5rem">{{ flightTitle }}</div>
                <div style="min-width: 3.75rem">{{ flightTime }}</div>
            </div>
        </td>
        <td style="min-width: 15vw">
            <club-schedule-athlete
                v-for="startList in startLists('TI')"
                :key="startList.athlete.id"
                :start-list="startList"
                event="TI"
                chip-class="blue--text font-weight-bold"
            />
        </td>
        <td style="min-width: 15vw">
            <club-schedule-athlete
                v-for="startList in startLists('DM')"
                :key="startList.athlete.id"
                :start-list="startList"
                event="DM"
                chip-class="green--text font-weight-bold"
            />
        </td>
        <td style="min-width: 15vw">
            <club-schedule-athlete
                v-for="startList in startLists('TU')"
                :key="startList.athlete.id"
                :start-list="startList"
                event="TU"
                chip-class="red--text font-weight-bold"
            />
        </td>
        <td v-if="showingSynColumn">
            <club-schedule-athlete
                v-for="startList in startLists('TS')"
                :key="startList.athlete.id"
                :start-list="startList"
                event="TS"
                chip-class="yellow--text font-weight-bold"
            />
        </td>
    </tr>
</template>

<script>
import sortBy from 'lodash/sortBy.js';
import ClubScheduleAthlete from '@/Components/Club/Schedule/ClubScheduleAthlete.vue';

export default {
    name: 'ClubScheduleFlights',

    components: { ClubScheduleAthlete },

    props: {
        flightTitle: {
            type: String,
            required: true,
        },

        flightTime: {
            type: String,
            required: true,
        },

        sessions: {
            type: Array,
            required: true,
        },

        active: {
            type: Boolean,
            default: false,
        },

        showingSynColumn: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        flights() {
            return this.sessions
                .map(session =>
                    session.flights
                        .filter(flight => flight.title === this.flightTitle)
                        .map(flight => {
                            return {
                                session,
                                flight,
                            };
                        }),
                )
                .flat();
        },
    },

    created() {
        this.sessions.map(session =>
            session.flights.forEach(flight => {
                flight.$update({ equipment: session.equipment });

                flight.start_lists.forEach(startList => {
                    startList.$update({ equipment: session.equipment });
                });
            }),
        );
    },

    methods: {
        startLists(event) {
            const eventFlights = this.flights.filter(flight => flight.flight.event === event);

            return sortBy(eventFlights.map(({ flight }) => flight.start_lists.flat()).flat(), 'order');
        },
    },
};
</script>
